import { createAction, props } from '@ngrx/store';

export const loadEntityList = createAction('[Entity] Load List');

export const loadEntityListSuccess = createAction(
  '[Entity] Load List Success',
  props<{ data: any[] }>()
);

export const loadEntityListFailure = createAction(
  '[Entity] Load List Failure',
  props<{ error: any }>()
);

export const clearEntityList = createAction('[Entity] Clear List');
